import { render, staticRenderFns } from "./MobileDraggable.vue?vue&type=template&id=0c9a8063&scoped=true"
import script from "./MobileDraggable.vue?vue&type=script&lang=js"
export * from "./MobileDraggable.vue?vue&type=script&lang=js"
import style0 from "./MobileDraggable.vue?vue&type=style&index=0&id=0c9a8063&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9a8063",
  null
  
)

export default component.exports